import React from "react";

const STATUS_META = {
  draft:            { label: "Draft",            cls: "bg-slate-100 text-slate-600 border-slate-200" },
  submitted:        { label: "Submitted",        cls: "bg-blue-50 text-blue-700 border-blue-200" },
  pending_approval: { label: "Pending Approval", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved:         { label: "Approved",         cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected:         { label: "Rejected",         cls: "bg-rose-50 text-rose-700 border-rose-200" },
  assigned:         { label: "Assigned",         cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  in_progress:      { label: "In Progress",      cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  paused:           { label: "Paused",            cls: "bg-amber-50 text-amber-700 border-amber-200" },
  returned:         { label: "Returned",          cls: "bg-purple-50 text-purple-700 border-purple-200" },
  completed:        { label: "Completed",        cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed:           { label: "Closed",           cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span data-testid={`status-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 text-[10px] font-heading uppercase tracking-[0.1em] font-bold border rounded-full whitespace-nowrap ${m.cls}`}>
      {m.label}
    </span>
  );
}

const PRIO_META = {
  low:    "bg-slate-50 text-slate-500 border-slate-200",
  normal: "bg-slate-50 text-slate-600 border-slate-200",
  high:   "bg-orange-50 text-orange-700 border-orange-200",
  urgent: "bg-rose-50 text-rose-700 border-rose-200",
};

export function PriorityBadge({ priority }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 text-[10px] font-heading uppercase tracking-[0.1em] font-bold border rounded-full whitespace-nowrap ${PRIO_META[priority] || PRIO_META.normal}`}>
      {priority}
    </span>
  );
}
